import { useEffect, useState } from "react";
import { LuFileBadge } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import { LuCheck, LuClock, LuCpu, LuLock, LuTriangleAlert } from "react-icons/lu";
import { CardStat } from "../../../components/CardStat/CardStat";
import ListLicenses from "../ListLicenses/ListLicenses";
import LicenseFilters from "./LicenseFilters";
import LicenseService from "../../../services/LicensesService";
import { LicenseDetailsProvider } from "../../../contexts/licenseDetails";
import { useAuth } from "../../../contexts/auth";

const Licenses = () => {
   const { can } = useAuth();
   const [filters, setFilters] = useState({ search: "" });
   const navigate = useNavigate();
   const location = useLocation();
   const [refreshKey, setRefreshKey] = useState(0);
   const [statesCount, setStatesCount] = useState({
      activeLicenses: 0,
      upcomingDueLicenses: 0,
      overdueLicenses: 0,
      blockedLicenses: 0,
      noAssociatedLicenses: 0,
   });
   const canGetStatesCount = can?.('bravas.accessControl.license.statesCount');

   async function getStatesCount() {
      const response = await LicenseService.getStatesCount();
      if (response.status === 200) {
         setStatesCount(response.data);
      }
   }

   useEffect(() => {
      if (location.state?.deletedId) {
         setRefreshKey((k) => k + 1);
         navigate(location.pathname, { replace: true, state: {} });
      }
   }, [location.state, navigate, location.pathname]);

   useEffect(() => {
      if (canGetStatesCount) {
         getStatesCount();
      }
   }, []);

   return (
      <div className="consulta-container">
         <div className="search-list-wrapper">
            <SearchContainer
               icon={<LuFileBadge size={20} />}
               title="Licenças"
               className="mb-0!"
               containerClassName="pb-0!"
               navigate={"../cadastro-licencas"}
               hideAddButton={true}
            />
            <Container className="pt-0!">
               <div className="flex flex-wrap items-center mb-3! px-0! mx-0! mt-0! justify-between! gap-3">
                  <div className="flex-1 min-w-72">
                     <LicenseFilters filtersApplied={setFilters} />
                  </div>
               </div>
            </Container>
            <Container>
               {canGetStatesCount && (
                  <div className="w-full grid grid-cols-5 gap-3 -mt-2! mb-3!">
                     <CardStat style={{ '--delay': 0 }} className="fade-in" title='Ativas' icon={LuCheck} value={`${statesCount.activeLicenses}`} color={`var(--activeLicensesColor)`} />
                     <CardStat style={{ '--delay': 1 }} className="fade-in" title='Vencem em 10 Dias' icon={LuClock} value={`${statesCount.upcomingDueLicenses}`} color={`var(--upcomingDueLicensesColor)`} />
                     <CardStat style={{ '--delay': 2 }} className="fade-in" title='Em atraso' icon={LuTriangleAlert} value={`${statesCount.overdueLicenses}`} color={`var(--expiredLicensesColor)`} />
                     <CardStat style={{ '--delay': 3 }} className="fade-in" title='Bloqueadas' icon={LuLock} value={`${statesCount.blockedLicenses}`} color={`var(--blockedLicensesColor)`} />
                     <CardStat style={{ '--delay': 4 }} className="fade-in" title='Sem dispositivo' icon={LuCpu} value={`${statesCount.noAssociatedLicenses}`} color={`var(--noDeviceLicensesColor)`} />
                  </div>
               )}
               <LicenseDetailsProvider>
                  <ListLicenses filters={filters} refreshKey={refreshKey} />
               </LicenseDetailsProvider>
            </Container>
         </div>
      </div>
   );
};

export default Licenses;
